// extracted by mini-css-extract-plugin
module.exports = {"qaViewHolder":"QASettings_qaViewHolder__3KcP5","qaSettingsHolder":"QASettings_qaSettingsHolder__1Le45","qaSettingsOptions":"QASettings_qaSettingsOptions__2P_Of"};